import React, { useMemo } from 'react';

import { Layout } from 'antd';
import cn from 'classnames';
import omit from 'lodash/omit'
import { inject, observer } from 'mobx-react'
import dynamic from 'next/dynamic'
import Head from 'next/head';
import { useRouter } from 'next/router'

import { fetchSymbols } from '@api/index'
import Navbar from '@components/Navbar'
import WebsocketKline from '@components/WebsocketKline'
import { Loading, Spin } from '@element/index'
import { formatFixNum } from '@kiki/web.utils.format-fix-num'
import { useTradeLoading } from '@lib/hooks/loading/useTradeLoading'
import { helper, I18n } from '@utils/index'
import { useMain, useTaradeCoinDetail } from '@widget/trade';

// import Amount from '@widget/trade/Amount'
// import EntrustEvent from '@widget/trade/EntrustEvent'
// import EntrustEventOperation from '@widget/trade/EntrustEvent/EntrustEventOperation'
// import { HistoryEntrustOperation } from '@widget/trade/EntrustEvent/HistoryEntrustOperation'
// import { HistoryTradeOpeartion } from '@widget/trade/EntrustEvent/HistoryTradeOpeartion'
import styles from '@styleModules/trade/detail.module.css'

const { Header } = Layout
const KLineMain = dynamic(() => import('@widget/trade')
  .then(T => T.KLineMain), {
  ssr: false
})

const T = (props) => {
  const { marketStore, tradeStore, tradingPair, coin } = props;
  const router = useRouter();
  const { status, updateLoadingState } = useTradeLoading({ mainStatus: 'loading' });
  const { coinCode } = router.query;
  const tradeCoinDetail = useTaradeCoinDetail({ marketStore, coinCode })
  const params = useMain({ marketStore, coinCode, tradeStore, updateLoadingState })
  const { onWebSocketReady, midPrice, precision } = params;
  const price = useMemo(() => {
    if (typeof midPrice !== 'number') {
      return midPrice;
    }
    return formatFixNum(helper.formatFixNumString(midPrice ?? 0, precision))
  }, [midPrice, precision])
  return (
    <Layout className={cn(styles.page, {
      [styles.pageLoading]: status !== 'success'
    })}>
      <Header>
        <Navbar></Navbar>
      </Header>
      <Head>
        <title>{I18n.t('trade_title', { price: price ?? '', tradingPair, coin })}</title>
        <meta property="og:title" content={I18n.t('trade_des', { coin, tradingPair })} key="title" name="description" />
      </Head>
      <Spin
        className={cn(styles.content, {
          [styles.contentLoading]: status !== 'success'
        })}
        loaddingClass={styles.loaddingWrapper}
        renderLoading={<Loading className={styles.loading} path='/animations/pulltorefresh.json' />}
        status={status}>
        <KLineMain {...omit(params, 'onWebSocketReady')} coinCode={coinCode} tradeCoinDetail={tradeCoinDetail} />
        <WebsocketKline onReady={onWebSocketReady} />
        {/* {
          !_isNewUser &&
          <div className={styles.bottom}>
            <EntrustEvent
              updateLoadingState={updateLoadingState}
              customNowEntrustRender={({ children, initFetchData, filterRef, isEmpty }) => {
                return (
                  <EntrustEventOperation
                    initFetchData={initFetchData}
                    filterRef={filterRef}
                    isEmpty={isEmpty}
                  >
                    {children}
                  </EntrustEventOperation>
                )
              }}
              customHistoryEntrustRender={({ children, initFetchData, filterRef, isEmpty }) => {
                return (
                  <HistoryEntrustOperation
                    initFetchData={initFetchData}
                    filterRef={filterRef}
                    isEmpty={isEmpty}
                  >
                    {children}
                  </HistoryEntrustOperation>
                )
              }}
              customHistoryTradeRender={({ children, initFetchData, filterRef, isEmpty }) => {
                return (
                  <HistoryTradeOpeartion
                    initFetchData={initFetchData}
                    filterRef={filterRef}
                    isEmpty={isEmpty}
                  >
                    {children}
                  </HistoryTradeOpeartion>
                )
              }}
            />
            <Amount updateLoadingState={updateLoadingState} />
          </div>
        } */}

      </Spin>
    </Layout>
  )
}

export default inject(rootStore => ({
  userStore: rootStore.store.userStore,
  tradeStore: rootStore.store.tradeStore,
  marketStore: rootStore.store.marketStore
}))(observer(T))

export async function getServerSideProps (ctx) {
  try {
    const res = await fetchSymbols()
    const newResObj = res.obj
    const index = newResObj.findIndex(item => item.coinCode === ctx?.query?.coinCode)
    if (index < 0) {
      ctx.res.writeHead(307, {
        Location: `/${ctx.locale}/404`
      }).end()
    }
  } catch (error) { }
  return { props: { price: 0, coin: ctx?.query?.coinCode.split('_')[0], tradingPair: ctx?.query?.coinCode.replace('_', '/') } }
}
